import React, { PropsWithChildren } from 'react';
import Message from '@ui/message/Message';
import FormPlaceholder from '@ui/placeholder/FormPlaceholder';
import useSecurity from '@util/SecurityHook';
import Authority from '@app/model/authentication/Authority';
import { useCompanySettings } from '@app/model/integration-settings/service/IntegrationSettingsHooks';

// The gate of the Integrations tab (decisions 4 and 6): an ADMIN of a company that RoomPulse switched on.
export const useIntegrationSettingsAllowed = (): { isAllowed: boolean, isLoading: boolean } => {
	const security = useSecurity();
	const { data, isLoading } = useCompanySettings();
	return { isAllowed: security.hasAccess([Authority.ADMIN]) && data?.enableIntegrationSettings === true, isLoading };
};

const IntegrationSettingsAccess: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
	const { isAllowed, isLoading } = useIntegrationSettingsAllowed();
	if (isLoading) return <FormPlaceholder />;
	if (!isAllowed) {
		return <Message state="info" title="Integration Settings are not switched on">
			Ask RoomPulse to switch on the Integration Settings for your company. Only an admin of the company can open them.
		</Message>;
	}
	return <>{children}</>;
};

export default IntegrationSettingsAccess;
